import dayjs from "dayjs";

export const CYCLE_OPTIONS = [
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

export const CURRENCY_OPTIONS = [{ value: "INR", label: "INR" }];

export const normalizeDiscountTypeFromApi = (type) => {
  if (type === "percentage" || type === "percent") return "percent";
  if (type === "fixed_amount") return "fixed_amount";
  return "percent";
};

export const getDefaultCouponFormValues = () => ({
  discount_type: "percent",
  currency: "INR",
  is_active: true,
  discount_value: 10,
  usage_limit: 100,
  usage_per_user: 1,
  applicable_plans: [],
  applicable_cycles: ["monthly", "yearly"],
});

export const couponToFormValues = (coupon) => ({
  code: coupon.code,
  name: coupon.name,
  description: coupon.description || undefined,
  discount_type: normalizeDiscountTypeFromApi(coupon.discount_type),
  discount_value:
    coupon.discount_value != null ? Number(coupon.discount_value) : undefined,
  usage_limit: coupon.usage_limit ?? undefined,
  usage_per_user: coupon.usage_per_user ?? undefined,
  min_order_amount: coupon.min_order_amount ?? undefined,
  currency: coupon.currency || "INR",
  valid_from: coupon.valid_from ? dayjs.unix(coupon.valid_from) : undefined,
  valid_until: coupon.valid_until ? dayjs.unix(coupon.valid_until) : undefined,
  applicable_plans: Array.isArray(coupon.applicable_plans)
    ? coupon.applicable_plans
    : [],
  applicable_cycles: Array.isArray(coupon.applicable_cycles)
    ? coupon.applicable_cycles
    : [],
  is_active: coupon.is_active === 1,
});

export const buildCouponPayload = (values) => {
  const payload = {
    code: values.code.trim().toUpperCase(),
    name: values.name.trim(),
    discount_type: values.discount_type,
    discount_value: values.discount_value,
    usage_limit: values.usage_limit,
    is_active: values.is_active ? 1 : 0,
    applicable_plans: values.applicable_plans || [],
    currency: values.currency || "INR",
    applicable_cycles: values.applicable_cycles || [],
  };

  if (values.description?.trim()) {
    payload.description = values.description.trim();
  }
  if (values.usage_per_user != null && values.usage_per_user !== "") {
    payload.usage_per_user = values.usage_per_user;
  }
  if (values.min_order_amount != null && values.min_order_amount !== "") {
    payload.min_order_amount = values.min_order_amount;
  }
  if (values.valid_from) {
    payload.valid_from = values.valid_from.startOf("day").unix();
  }
  if (values.valid_until) {
    payload.valid_until = values.valid_until.endOf("day").unix();
  }

  return payload;
};
